import { SensitiveDataFormFieldOptionType } from "types/Models/sensitiveData";

export type SensitiveDataSelectOption = {
  value: string;
  label: string;
  codeAlpha2?: string;
};

export const getSensitiveDataSelectOptions = (
  options: SensitiveDataFormFieldOptionType[] = []
): SensitiveDataSelectOption[] =>
  options.map((option) => {
    if ("value" in option) {
      return { value: option.value, label: option.label };
    }

    return {
      value: option.name,
      label: option.name,
      codeAlpha2: option.code_alpha_2,
    };
  });
